// routes/_app.referral.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.referral')

export const handle = { name: 'referral' }

export default dynamic(getClientModule, { ssr: false })
